import { useQuery } from "@apollo/client";
import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { FRANCE_ADDRESS_ZIP_CODE_CITY } from "utils/api/graphql/queries/referentials";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import Select from "../Components/Select";
import validation from "./validation";

function View({ telecoms, onNext, onBack }) {
  const { t } = useTranslation();

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: { telecoms },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  const { data: cities, loading } = useQuery(FRANCE_ADDRESS_ZIP_CODE_CITY, {
    variables: {
      where: {
        zipCode: get(values, `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`),
      },
    },
  });
  const citiesArray = get(cities, "franceAddressZipCodeCity.response", []);

  return (
    <Layout>
      <Header
        title="Pourriez-vous indiquer votre <b>adresse complète ?</b>"
        highlight="indiquer votre"
        subtitle="Votre localisation"
        onBack={onBack}
      />
      <Row justify="center">
        <Col xs={24} md={18}>
          <div className="grid--2 pb-16">
            <Input
              placeholder={"Numéro et voie"}
              label={"Numéro et voie"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`,
                values,
                ...formProps,
              })}
            />
            <Input
              placeholder={"Lieu – Dit"}
              label={"Lieu – Dit"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS_LOCATION}.value`,
                values,
                ...formProps,
              })}
              optional
            />
          </div>
          <div className="grid--2 pb-16">
            <Input
              disabled
              placeholder={"ex : 69001"}
              label={"Code postal"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                values,
                ...formProps,
              })}
            />
            <Select
              showSearch
              loading={loading}
              options={citiesArray}
              placeholder={"Sélectionnez ..."}
              label={"Ville"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.CITY}.value`,
                values,
                ...formProps,
              })}
            />
          </div>
          <div className="grid--2">
            <Input
              placeholder={"Appartement / étage"}
              label={"Appartement / étage"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.COMPLEMENT}.value`,
                values,
                ...formProps,
              })}
              optional
            />
            <Input
              placeholder={"Résidence / Bâtiment"}
              label={"Résidence / Bâtiment"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.RESIDENCE}.value`,
                values,
                ...formProps,
              })}
              optional
            />
          </div>
        </Col>
      </Row>

      <ActionButtons
        disabled={
          !get(values, `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`) ||
          !isEmpty(formProps.errors)
        }
        onNext={handleSubmit}
        onBack={onBack}
        buttonText="Continuer"
      />
    </Layout>
  );
}

export default View;
